import { useLocation, useNavigate } from "react-router-dom";
import { useSettings } from "@/hooks/SettingsContext";
import { trackPlanVisitClick } from "@/lib/analytics";

export default function StickyCTA() {
  const location = useLocation();
  const navigate = useNavigate();
  const { settings } = useSettings();
  if (location.pathname.startsWith("/admin")) return null;

  const launch = settings?.launch_mode !== false;
  const label = launch ? "PLAN YOUR VISIT - SERVICE #1" : "PLAN YOUR VISIT";

  const go = () => {
    trackPlanVisitClick();
    const targetId = launch ? "service-1" : "plan-your-visit";
    const targetPath = launch ? "/" : "/im-new";
    if (location.pathname === targetPath) {
      document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(targetPath);
      setTimeout(() => document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" }), 500);
    }
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 backdrop-blur-md sm:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-sticky-cta-bar"
    >
      <button
        type="button"
        onClick={go}
        data-testid="sticky-mobile-cta"
        className="flex h-11 w-full items-center justify-center bg-victory font-display text-[13px] font-700 tracking-[0.1em] text-white transition-colors active:bg-victory-dark"
      >
        {label}
      </button>
    </div>
  );
}
